// extracted by mini-css-extract-plugin
export default {"modal":"del_modal__utyfr","img":"del_img__Buc+3","btnDiv":"del_btnDiv__n97Hm","btn":"del_btn__AhCZi"};